import React, { useState } from "react";
import { Link, useParams } from "react-router-dom";
import { ChevronRight, ListFilter, Grid3X3, Rows3 } from "lucide-react";
import CategorySidebar from "../components/CategorySidebar";
import ProductCard from "../components/ProductCard";
import { PRODUCTS, CATEGORIES } from "../data/mock";

const CategoryPage = () => {
  const { slug } = useParams();
  const [sort, setSort] = useState("featured");
  const category = CATEGORIES.find((c) => c.slug === slug);
  let items = slug ? PRODUCTS.filter((p) => p.category === slug) : PRODUCTS;
  if (sort === "price-asc") items = [...items].sort((a, b) => a.fromPrice - b.fromPrice);
  if (sort === "price-desc") items = [...items].sort((a, b) => b.fromPrice - a.fromPrice);
  if (sort === "rating") items = [...items].sort((a, b) => b.rating - a.rating);

  return (
    <main className="bg-white">
      {/* breadcrumb header */}
      <div className="bg-gradient-to-r from-zinc-50 to-rose-50/30 border-b border-zinc-100">
        <div className="max-w-7xl mx-auto px-4 py-10">
          <nav className="text-xs text-zinc-500 mb-3 flex items-center gap-2">
            <Link to="/" className="hover:text-rose-500">Home</Link>
            <ChevronRight className="w-3 h-3" />
            <Link to="/shop" className="hover:text-rose-500">Shop</Link>
            {category && (<><ChevronRight className="w-3 h-3" /><span className="text-zinc-900">{category.name}</span></>)}
          </nav>
          <h1 className="text-4xl font-bold text-zinc-900">{category ? category.name : "All Products"}</h1>
          <p className="text-zinc-600 mt-2">{items.length} products available · free local pickup in Fort Lauderdale</p>
        </div>
      </div>

      <div className="max-w-7xl mx-auto px-4 py-10 flex flex-col lg:flex-row gap-8">
        <CategorySidebar />
        <div className="flex-1">
          {/* sort bar */}
          <div className="flex items-center justify-between mb-6 pb-4 border-b border-zinc-100">
            <span className="text-sm text-zinc-600">Showing {items.length} results</span>
            <div className="flex items-center gap-3">
              <ListFilter className="w-4 h-4 text-zinc-400" />
              <select value={sort} onChange={(e) => setSort(e.target.value)} className="text-sm border border-zinc-200 rounded-md px-3 py-2 outline-none focus:border-rose-400">
                <option value="featured">Sort: Featured</option>
                <option value="price-asc">Price: Low to High</option>
                <option value="price-desc">Price: High to Low</option>
                <option value="rating">Top Rated</option>
              </select>
              <button className="w-9 h-9 rounded-md border border-zinc-200 flex items-center justify-center text-rose-500 bg-rose-50"><Grid3X3 className="w-4 h-4" /></button>
              <button className="w-9 h-9 rounded-md border border-zinc-200 flex items-center justify-center text-zinc-500 hover:text-rose-500"><Rows3 className="w-4 h-4" /></button>
            </div>
          </div>

          {items.length === 0 ? (
            <div className="py-20 text-center text-zinc-500">No products found in this category yet.</div>
          ) : (
            <div className="grid grid-cols-2 md:grid-cols-3 gap-5">
              {items.map((p) => <ProductCard key={p.slug} product={p} />)}
            </div>
          )}
        </div>
      </div>
    </main>
  );
};

export default CategoryPage;
